import { render, staticRenderFns } from "./ECommerceWishList.vue?vue&type=template&id=0c8a39ff&scoped=true&"
import script from "./ECommerceWishList.vue?vue&type=script&lang=js&"
export * from "./ECommerceWishList.vue?vue&type=script&lang=js&"
import style0 from "./ECommerceWishList.vue?vue&type=style&index=0&id=0c8a39ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8a39ff",
  null
  
)

export default component.exports